import { httpClient2 } from 'src/infrastructure/admi-client/http-client';

/**
 * One of the 16 German Bundesländer. `code` is the 2-digit AGS/ARS Land
 * prefix (`"01"` Schleswig-Holstein … `"16"` Thüringen), which is the
 * shape stored in `customer_tasks.region` and accepted by the REA list
 * view's region filter.
 */
export interface FederalState {
    code: string;
    name: string;
}

export const admiFederalStateService = {
    /**
     * Returns the 16 Bundesländer ordered by code. The result is stable
     * reference data, so callers cache it for the page lifetime rather
     * than refetching per render.
     */
    async list(): Promise<FederalState[]> {
        const response = await httpClient2.get<FederalState[]>('/v1/federal-states');
        return response.data;
    },
};
